import { Box, Hidden, Typography } from "@material-ui/core";
import React from "react";

import { StyledGrid } from "components/simple";
import { fontSize, spacingDefaults } from "style/constants";

type Props = {
  name: string;
  score?: number | null;
};

const SingleBHQScore: React.FC<Props> = ({ name, score }: Props) => {
  return (
    <StyledGrid paddingLeft={spacingDefaults.large} paddingRight={spacingDefaults.large}>
      <StyledGrid paddingTop={spacingDefaults.large} paddingBottom={spacingDefaults.large}>
        <StyledGrid container direction="row" justifyContent="space-between" alignItems="center">
          <StyledGrid alignItems="center" container item xs>
            <StyledGrid>{name}</StyledGrid>
          </StyledGrid>

          <StyledGrid container item xs={8} direction="row" justifyContent="flex-end">
            <Hidden mdDown>
              <StyledGrid item>{score && score}</StyledGrid>
            </Hidden>

            <StyledGrid item marginLeft={spacingDefaults.xlarge}>
              {(score === null || typeof score == "undefined" || score < 0) && (
                <Typography variant="body1" color="textSecondary">
                  <i>Assessment Not Started</i>
                </Typography>
              )}
            </StyledGrid>
          </StyledGrid>
        </StyledGrid>
      </StyledGrid>
    </StyledGrid>
  );
};

export default SingleBHQScore;
